import { Container } from "../styles";
import { comum } from "../../../../../../../../styles/Themes/light";
import { IconUser } from "../../../../../../../icons";
import { useAuth } from "../../../../../../../../contexts/UserContext";
import { podeEditarDemanda, usuarioEhSolicitante } from "../../../../../../../../helpers/permissoesUsuario";
import InputEditavel from "../../../../../../../form/InputEditavel";

interface CardParteClienteProps {
    demanda: any;
    isEditing?: boolean;
    isDisabled?: boolean;
    onChange?: (campo: string, valor: any) => void;
    onBlur?: (campo: string) => void;
    errors?: Record<string, string>;
}

export default function CardParteCliente({demanda, isEditing = false, isDisabled = false, onChange, onBlur, errors}: CardParteClienteProps) {
    const { user } = useAuth();

    const temCliente = demanda?.nome_cliente || demanda?.codigo_cliente;
    const podeAdicionarCliente = podeEditarDemanda(user) && isEditing;
    const deveMostrarInputs = podeAdicionarCliente;

    const handleNomeClienteChange = (value: string) => {
        if (onChange) {
            onChange('nome_cliente', value);
        }
    };

    const handleCodigoClienteChange = (value: string) => {
        if (onChange) {
            onChange('codigo_cliente', value);
        }
    };

    if (usuarioEhSolicitante(user)) {
        return null;
    }

    return (
        <Container>
            <span className="label">Cliente</span>
            
            {deveMostrarInputs ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '10px' }}>
                    <InputEditavel
                        value={demanda?.nome_cliente}
                        onChange={handleNomeClienteChange}
                        onBlur={() => onBlur && onBlur('nome_cliente')}
                        isEditing={isEditing}
                        disabled={isDisabled}
                        placeholder="Digite o nome do cliente"
                        error={errors?.nome_cliente}
                    />
                    <InputEditavel
                        value={demanda?.codigo_cliente}
                        onChange={handleCodigoClienteChange}
                        onBlur={() => onBlur && onBlur('codigo_cliente')}
                        isEditing={isEditing}
                        disabled={isDisabled}
                        placeholder="Digite o código do cliente"
                        error={errors?.codigo_cliente}
                    />
                </div>
            ) : temCliente ? (
                <div className="parte">
                    <div className="iconc">
                        <IconUser color={comum.colors.primaryRed400}/>
                    </div>
                    <div className="info">
                        <span className="nome">{demanda?.nome_cliente || 'N/A'}</span>
                        <span className="codigo">{demanda?.codigo_cliente || 'N/A'}</span>
                    </div>
                </div>
            ) : (
                <div className="parte-vazio">
                    Nenhum cliente atribuído
                </div>
            )}
        </Container>
    )
}

